import { render } from "./add-course-modal.vue?vue&type=template&id=240de2c1&scoped=true"
import script from "./add-course-modal.vue?vue&type=script&lang=js"
export * from "./add-course-modal.vue?vue&type=script&lang=js"

import "./add-course-modal.vue?vue&type=style&index=0&id=240de2c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240de2c1"]])

export default __exports__